/**
 * [name of the sound that triggers ducking of the music]: time of ducking and unducking
 */

export interface DuckingConfig {
	[soundName: string]: DuckingConfigData;
}

export interface DuckingConfigData {
	duckingTime?: number;
	unduckingTime?: number;
	sounds: SoundMusicVoiceOptionSwitch;
}

export interface SoundMusicVoiceOptionSwitch {
	music: boolean;
	effects: boolean;
	voice: boolean;
}

export class SoundsDuckingConfig {
	private _duckingConfig: DuckingConfig = {};

	public constructor() {
		this.init();
	}

	public init(): void {
		this.setupDuckingConfigs();
		this.setupUnduckingConfigs();
	}

	public hasDuckingTimeFor(soundName: string): boolean {
		return this.hasDuckingConfigFor(soundName) && this._duckingConfig[soundName].hasOwnProperty('duckingTime');
	}

	public getDuckingTimeFor(soundName: string): number {
		return this._duckingConfig[soundName].duckingTime;
	}

	public getDuckingSoundsFor(soundName: string): SoundMusicVoiceOptionSwitch {
		return this._duckingConfig[soundName].sounds;
	}

	public hasUnduckingFor(soundName: string): boolean {
		return this._duckingConfig.hasOwnProperty(soundName) && this._duckingConfig[soundName].hasOwnProperty('unduckingTime');
	}

	public getUnduckingTimeFor(soundName: string): number {
		return this._duckingConfig[soundName].unduckingTime;
	}

	protected hasDuckingConfigFor(soundName: string): boolean {
		return this._duckingConfig.hasOwnProperty(soundName);
	}

	protected setupDuckingConfigs(): void {
		// Example use.
		this.addDuckingConfig('bigwin', 300, {music: true, effects: false, voice: false});
	}

	protected setupUnduckingConfigs(): void {}

	protected addDuckingConfig(
		soundId: string,
		duckingTime: number,
		sounds: SoundMusicVoiceOptionSwitch = {music: true, effects: false, voice: false},
	): void {
		if (this._duckingConfig[soundId]) {
			this._duckingConfig[soundId].duckingTime = duckingTime;
			this._duckingConfig[soundId].sounds = sounds;
		} else {
			this._duckingConfig[soundId] = {duckingTime, sounds};
		}
	}

	protected addUnduckingConfig(
		soundId: string,
		unduckingTime: number,
		sounds: SoundMusicVoiceOptionSwitch = {music: true, effects: false, voice: false},
	): void {
		if (this._duckingConfig[soundId]) {
			this._duckingConfig[soundId].unduckingTime = unduckingTime;
			this._duckingConfig[soundId].sounds = sounds;
		} else {
			this._duckingConfig[soundId] = {unduckingTime, sounds};
		}
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/sound/SoundsDuckingConfig.ts